var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostUploadVideoSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0813 4.8C13.9781 4.8 13.8781 4.82813 13.7906 4.88438L11.0875 6.59062C11.0094 6.64062 10.9625 6.725 10.9625 6.81563V9.19063C10.9625 9.28125 11.0094 9.36562 11.0875 9.41562L13.7906 11.1219C13.8781 11.175 13.9781 11.2063 14.0813 11.2063H14.7312C14.8812 11.2063 15 11.0875 15 10.9406V5.06563C15 4.91875 14.8781 4.8 14.7312 4.8H14.0813ZM8.54688 12H2.60938C1.725 12 1 11.275 1 10.3938V5.60625C1 4.72187 1.725 4 2.60625 4H8.54375C9.42812 4 10.15 4.725 10.15 5.60625V10.3906C10.1531 11.275 9.43125 12 8.54688 12Z",
    fill: "#156563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostUploadVideoSvg);
export default __webpack_public_path__ + "static/media/PostUploadVideoSvg.5e9d26926ed94e71a3c2a393d070dc95.svg";
export { ForwardRef as ReactComponent };